export const numberWithCommas = (x: number, digits?: number) => {
    const roundedNumber = digits !== undefined ? x.toFixed(digits) : x
    const splitNumber = roundedNumber.toString().split('.')
    splitNumber[0] = splitNumber[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',')
    return splitNumber.join('.')
}
